import type { AnalyticsProviderInterface } from '../analyticsProvider';

/**
 * Send event data to Google Analytics via dataLayer (GTM compatible)
 */
export const sendEvent = (event: string, content?: any) => {
    try {
        if (window.dataLayer !== undefined) {
            window.dataLayer.push({
                event: event,
                ...content,
            });
        } else if (window.gtag !== undefined) {
            window.gtag('event', event, content);
        }
    } catch {
        // GTM tags may reference scripts (e.g. fbq) not yet loaded
    }
};

export default { sendEvent } as AnalyticsProviderInterface;
